<div class="container">
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-8 mx-auto">
        <div class="card my-5">
          <div class="card-body">
            <h3 class="card-title text-center">U wordt uitgelogd, een ogenblik geduld.</h3>
          </div>
        </div>
      </div>
    </div>
  </div>